var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.RegisterShow,
          expression: "RegisterShow"
        }
      ],
      staticClass: "registerContainer"
    },
    [
      _c("div", { staticClass: "background" }, [
        _c("section", { staticClass: "main clearfix" }, [
          _c("i", { staticClass: "el-icon-close", on: { click: _vm.colse } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contFr fr" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  staticStyle: {},
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "1px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItems",
                      attrs: { label: "", prop: "mobile" }
                    },
                    [
                      _c("img", {
                        staticClass: "iconfonts",
                        attrs: {
                          src: require("@/assets/images/icon/phone1.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input clearfix",
                        attrs: {
                          placeholder: "请输入您的手机号",
                          maxlength: "11"
                        },
                        model: {
                          value: _vm.ruleForm.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "mobile", $$v)
                          },
                          expression: "ruleForm.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItems",
                      attrs: { label: "", prop: "passWord" }
                    },
                    [
                      _c("img", {
                        staticClass: "iconfonts",
                        attrs: {
                          src: require("@/assets/images/icon/paswd1.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input clearfix",
                        attrs: {
                          placeholder: "请输入密码/8-12位数字及字母组合而成",
                          "show-password": "",
                          minlength: "8",
                          maxlength: "12"
                        },
                        model: {
                          value: _vm.ruleForm.passWord,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "passWord", $$v)
                          },
                          expression: "ruleForm.passWord"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItems",
                      attrs: { label: "", prop: "repeatpassWord" }
                    },
                    [
                      _c("img", {
                        staticClass: "iconfonts",
                        attrs: {
                          src: require("@/assets/images/icon/paswd1.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input clearfix",
                        attrs: {
                          placeholder: "请确认密码",
                          "show-password": "",
                          maxlength: "12"
                        },
                        model: {
                          value: _vm.ruleForm.repeatpassWord,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "repeatpassWord", $$v)
                          },
                          expression: "ruleForm.repeatpassWord"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItems1",
                      staticStyle: { "margin-bottom": "22px" },
                      attrs: { label: "", prop: "regCode" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "clearfix" },
                        [
                          _c("el-input", {
                            staticClass: "input",
                            attrs: { placeholder: "请输入计算结果" },
                            model: {
                              value: _vm.ruleForm.regCode,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "regCode", $$v)
                              },
                              expression: "ruleForm.regCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "codeBox imgCode",
                        attrs: { src: _vm.imgCode, alt: "图形验证码" },
                        on: { click: _vm.getImgCodes }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItems1",
                      attrs: { label: "", prop: "verifyCode" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "clearfix" },
                        [
                          _c("el-input", {
                            staticClass: "input",
                            attrs: { placeholder: "请输入短信验证码" },
                            model: {
                              value: _vm.ruleForm.verifyCode,
                              callback: function($$v) {
                                _vm.$set(_vm.ruleForm, "verifyCode", $$v)
                              },
                              expression: "ruleForm.verifyCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "codeBox code",
                          on: {
                            click: function($event) {
                              return _vm.getCode()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.codeTxt))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "margin-top": "10px"
                      },
                      attrs: { label: "", prop: "checked" }
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.ruleForm.checked,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "checked", $$v)
                            },
                            expression: "ruleForm.checked"
                          }
                        },
                        [
                          _c("el-checkbox", {
                            staticClass: "myRedCheckBox",
                            attrs: { label: "我已阅读并同意" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "agreement",
                          on: {
                            click: function($event) {
                              return _vm.agreementS(1)
                            }
                          }
                        },
                        [_vm._v("《注册协议》")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "agreement",
                          on: {
                            click: function($event) {
                              return _vm.agreementS(2)
                            }
                          }
                        },
                        [_vm._v("《隐私协议》")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "register",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("ruleForm")
                            }
                          }
                        },
                        [_vm._v("注册账号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "goLogin",
                          attrs: { href: "javascript:void(0)" },
                          on: { click: _vm.goLogin }
                        },
                        [_vm._v("已有账号，去登录")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.agreement_Show,
              expression: "agreement_Show"
            }
          ],
          staticClass: "agreement_Model"
        },
        [
          _c("div", { staticClass: "agreement_box" }, [
            _c("p", { staticClass: "agreement_Title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.agreementState == 1 ? "注册协议" : "隐私协议")
                )
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-close",
                on: {
                  click: function($event) {
                    _vm.agreement_Show = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "agreement_Content" }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.agreement) } })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("Messages", { ref: "messages", attrs: { tips: _vm.tipsTxt } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e86116e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e86116e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterPopup.vue
// module id = null
// module chunks = 